import { useState } from 'react';
import api from '../../services/api';
import { Goal, Task, LifeCategory } from './types';

export interface Project {
  id: number;
  userId: number;
  name: string;
  createdAt: string;
  updatedAt: string;
}

export const useGoalsData = () => {
  const [goals, setGoals] = useState<Goal[]>([]);
  const [tasks, setTasks] = useState<Task[]>([]);
  const [categories, setCategories] = useState<LifeCategory[]>([]);
  const [projects, setProjects] = useState<Project[]>([]);
  const [loading, setLoading] = useState(true);

  const loadData = async () => {
    try {
      const [goalsRes, tasksRes, categoriesRes, projectsRes] = await Promise.all([
        api.get('/api/goals'),
        api.get('/api/tasks'),
        api.get('/api/life-categories'),
        api.get('/api/projects')
      ]);
      setGoals(goalsRes.data);
      setTasks(tasksRes.data);
      setCategories(categoriesRes.data);
      setProjects(projectsRes.data);
      return goalsRes.data;
    } catch (error) {
      console.error('Failed to load data:', error);
      return goals;
    } finally {
      setLoading(false);
    }
  };

  return {
    goals,
    tasks,
    categories,
    projects,
    loading,
    loadData,
    setGoals,
    setTasks,
    setCategories,
    setProjects
  };
};
